import { withStyles } from "@material-ui/core";
import { Col, Row } from "antd";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import PostDataController from "../../Controller/PostDataController.js";
import * as Constants from "../../Pages/Constants";
import * as KidneyConstants from "./KidneyConstants.js";

const State = {
  START: "start",
  CONTINUE: "continue",
  END: "end",
};

const getResult = (label, data) => {
  try {
    const index = data.findIndex((r) => r.label === label);
    return data[index].value;
  } catch (e) {
    console.log("KidneyMachineForm error getting value from form " + label);
  }
  return undefined;
};

const KidneyMachineForm = (props) => {
  const { classes } = props;
  let lastState = undefined;
  let lastDryWeight = "0";
  let lastRealWeightAtSessionStart = "0";
  try {
    lastState = getResult("session_state", props.lastKidneyDeviceForm);
    lastDryWeight = getResult("dry_weight_at_session_start", props.lastKidneyDeviceForm);
    lastRealWeightAtSessionStart = getResult("real_weight_at_session_start", props.lastKidneyDeviceForm);
  } catch (e) {
    // console.log("Device kidney form : Didn't find last kidney device form data ");
    // -> Suggest new session
  }

  let optionsSession = {};
  let newDefaultState = undefined;
  if (lastState === State.START || lastState === State.CONTINUE) {
    optionsSession = {
      continue: KidneyConstants.getFormStateMsg("continue", props.intl.formatMessage),
      end: KidneyConstants.getFormStateMsg("end", props.intl.formatMessage),
    };
    newDefaultState = State.CONTINUE;
  } else {
    optionsSession = {
      start: KidneyConstants.getFormStateMsg("start", props.intl.formatMessage),
    };
    newDefaultState = State.START;
  }

  const [results, setResults] = useState([
    { label: "session_state", value: newDefaultState },
    { label: "dry_weight_at_session_start", value: lastDryWeight },
    { label: "real_weight_at_session_start", value: lastRealWeightAtSessionStart },
    { label: "real_weight", value: "0" },
    { label: "vein_pressure", value: "0" },
    { label: "blood_pressure", value: "0" },
    { label: "bags_volume", value: "0" },
    { label: "ultrafiltration_rate", value: "0" },
    { label: "peritoneal_liquid", value: "" },
    { label: "compression_duration", value: "0" },
  ]);
  const [peritonealLiquidValue, setPeritonealLiquidValue] = useState("");
  const [sessionStateValue, setSessionStateValue] = useState("");

  const optionsBloodViscosity = KidneyConstants.getBloodViscosityOptionsMap(props.intl.formatMessage);

  const sendingForm = async () => {
    if (getResult("session_state", results) === State.START) {
      const real_weight = getResult("real_weight", results);
      const index = results.findIndex((r) => r.label === "real_weight_at_session_start");
      results[index] = { label: "real_weight_at_session_start", value: real_weight };
    }

    let to_send = [...results];

    to_send.unshift({ label: "form_type", value: "kidney_device" });

    // Send data in backend & update display
    const current_Date = new Date();
    // Zero out milliseconds to ensure consistency between backend and frontend
    current_Date.setMilliseconds(0);

    await PostDataController.post_observation(current_Date, to_send, "health_form", props.id_patient); // Send data in backend

    await props.update(current_Date, results);

    props.cancelPopup();
  };

  const changeResultValue = (e) => {
    let new_results = [...results];
    let index = new_results.findIndex((r) => r.label === e.target.name);
    new_results[index] = { label: e.target.name, value: e.target.value };
    setResults(new_results);
  };

  const changeSelect = (e) => {
    if (e.target.id === "peritoneal_liquid") {
      let selectedIndex = e.target.options.selectedIndex;
      if (selectedIndex < 1 || selectedIndex > Object.keys(optionsBloodViscosity).length) return;

      let selectedKey = Object.keys(optionsBloodViscosity)[selectedIndex];

      // Update the results state for peritoneal_liquid
      let new_results = [...results];
      let index = new_results.findIndex((r) => r.label === "peritoneal_liquid");
      new_results[index] = { label: "peritoneal_liquid", value: selectedKey };
      setPeritonealLiquidValue(e.target.value);
      setResults(new_results);
    } else if (e.target.id === "session_state") {
      let selectedIndex = e.target.options.selectedIndex;
      if (selectedIndex < 0 || selectedIndex > Object.keys(optionsSession).length) return;

      let selectedKey = Object.keys(optionsSession)[selectedIndex];

      // Update the results state for session_state
      let new_results = [...results];
      let index = new_results.findIndex((r) => r.label === "session_state");
      new_results[index] = { label: "session_state", value: selectedKey };
      setSessionStateValue(e.target.value);
      setResults(new_results);
    }
  };

  const generateSelect = (message_id, field_id, option, value) => {
    return (
      <div>
        <Row style={{ width: "100%", color: "black", textAlign: "left", padding: "0.5rem" }}>
          <Col style={{ width: "5%" }}></Col>
          <Col style={{ width: "50%" }}>
            <FormattedMessage id={message_id} defaultMessage={message_id} />
          </Col>
          <Col style={{ width: "45%" }}>
            <select value={value} onChange={(e) => changeSelect(e)} id={field_id} name={field_id} style={{ maxWidth: "100%", margin: "0%" }}>
              {Object.entries(option).map(([key, value]) => (
                <option value={value} key={key}>
                  {value}
                </option>
              ))}
            </select>
          </Col>
        </Row>
      </div>
    );
  };

  const renderInputOneSelect = (message_id, defaultMessage, input_name, select_value, select_change) => {
    return (
      <Row style={{ width: "100%", color: "black", textAlign: "left", padding: "0.3rem" }}>
        <Col style={{ width: "5%" }}></Col>
        <Col style={{ width: "50%" }}>
          <FormattedMessage id={message_id} defaultMessage={defaultMessage} />
        </Col>
        <Col style={{ width: "15%" }}>
          <input style={{ width: "100%" }} type="number" name={input_name} min={0} step={1} precision={1} value={getResult(input_name, results)} onChange={(e) => changeResultValue(e)} />
          <br />
        </Col>
        <Col style={{ width: "15%", textAlign: "right" }}></Col>
        <Col style={{ width: "15%", textAlign: "right" }}></Col>
      </Row>
    );
  };

  const generatePageKidneyMachine = () => {
    return (
      <div style={{ color: "black" }}>
        <Row style={{ fontWeight: "bold", fontSize: "1.5em", display: "block", textAlign: "center" }}>
          <FormattedMessage id="kidney.form.machine.title" defaultMessage="Machine monitoring" />
        </Row>
        <FormattedMessage id="kidney.form.machine.advise" defaultMessage="Use connected devices" />

        <br />
        {generateSelect("kidney.form.machine.session.session_state", "session_state", optionsSession, sessionStateValue)}
        {getResult("session_state", results) === State.START ? renderInputOneSelect("kidney.form.machine.dry_weight_at_session_start", "", "dry_weight_at_session_start", 0, changeResultValue) : null}
        {renderInputOneSelect("kidney.form.machine.real_weight", "", "real_weight", 0, changeResultValue)}
        {renderInputOneSelect("kidney.form.machine.one", "Device venous pressure", "vein_pressure", 0, changeResultValue)}
        {renderInputOneSelect("kidney.form.machine.two", "Device blood pressure", "blood_pressure", 0, changeResultValue)}
        {renderInputOneSelect("kidney.form.machine.three", "Bags volume", "bags_volume", 0, changeResultValue)}
        {renderInputOneSelect("kidney.form.machine.four", "Ultrafiltration rate", "ultrafiltration_rate", 0, changeResultValue)}
        {generateSelect("kidney.form.machine.liquid", "peritoneal_liquid", optionsBloodViscosity, peritonealLiquidValue)}
        {getResult("session_state", results) === State.END ? renderInputOneSelect("kidney.form.machine.five", "Compression duration", "compression_duration", 0, changeResultValue) : null}
      </div>
    );
  };

  let generalFormWidth = "75%";
  if (props.screenSize.width < 800) {
    generalFormWidth = "100%";
  }
  return (
    <div className={classes.popup_background}>
      <div style={{ width: { generalFormWidth }, height: "100%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
        <div className="submit-form" style={{ borderRadius: "5px" }}>
          {generatePageKidneyMachine()}
          <br />
          <button onClick={props.cancelPopup} className="btn btn-danger mx-1">
            <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
          </button>
          <button onClick={sendingForm} className="btn btn-success mx-1">
            <FormattedMessage id="button.submit" defaultMessage="Submit" />
          </button>
        </div>
      </div>
    </div>
  );
};
export default withStyles(Constants.styles)(KidneyMachineForm);
